import React, { useEffect, useRef, useState } from "react";
import { cropGeometry, SUPPLIER_IMAGE_CSS_RATIO, supplierOriginalPreview } from "../utils/supplierImage";
import "./SupplierImageCropper.css";

export default function SupplierImageCropper({ source, onConfirm, onChange, disabled = false }) {
  const [image, setImage] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: .5, y: .5 });
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState("");
  const frame = useRef(null);
  const drag = useRef(null);
  const src = supplierOriginalPreview(source);
  useEffect(() => {
    setImage(null); setZoom(1); setPosition({ x: .5, y: .5 }); setConfirmed(false); setError("");
  }, [source]);
  const crop = image ? cropGeometry(image, zoom, position) : null;
  const change = (fn) => {
    setConfirmed(false); onChange?.(); fn();
  };
  const picture = crop ? {
    width: `${100 / crop.width}%`, height: `${100 / crop.height}%`,
    left: `${-100 * crop.x / crop.width}%`, top: `${-100 * crop.y / crop.height}%`,
  } : {};
  const move = (e) => {
    if (!drag.current || disabled || !crop) return;
    const rect = frame.current.getBoundingClientRect();
    const dx = (e.clientX - drag.current.x) / rect.width * crop.width;
    const dy = (e.clientY - drag.current.y) / rect.height * crop.height;
    change(() => setPosition({
      x: Math.max(0, Math.min(1, drag.current.position.x - dx / (1 - crop.width || 1))),
      y: Math.max(0, Math.min(1, drag.current.position.y - dy / (1 - crop.height || 1))),
    }));
  };
  return <div className="supplier-cropper" style={{ "--supplier-image-ratio": SUPPLIER_IMAGE_CSS_RATIO }}>
    <details><summary>Mostra immagine originale</summary>
      <img className="supplier-cropper-original" src={src} alt="Originale del fornitore" />
    </details>
    <p>Trascina la foto e regola lo zoom. Il riquadro mostra il risultato finale.</p>
    <div className="supplier-cropper-frame" ref={frame}
      onPointerDown={(e) => {
        if (disabled || !image || e.button !== 0) return;
        e.currentTarget.setPointerCapture(e.pointerId);
        drag.current = { x: e.clientX, y: e.clientY, position };
      }} onPointerMove={move} onPointerUp={() => { drag.current = null; }}
      onPointerCancel={() => { drag.current = null; }}>
      <img key={source} src={src} alt="Anteprima del ritaglio" draggable={false} style={picture}
        onLoad={(e) => setImage({ width: e.currentTarget.naturalWidth, height: e.currentTarget.naturalHeight })}
        onError={() => { setImage(null); setError("Impossibile caricare l'originale. Riprova o scegli una nuova foto."); }} />
    </div>
    {!image && !error && <span>Caricamento immagine…</span>}
    {error && <span role="alert">{error}</span>}
    <label>Zoom <input aria-label="Zoom foto" type="range" min="1" max="5" step="0.01" value={zoom}
      disabled={disabled || !image} onChange={e => change(() => setZoom(Number(e.target.value)))} /></label>
    <label>Spostamento orizzontale <input aria-label="Posizione orizzontale" type="range" min="0" max="1" step="0.01" value={position.x}
      disabled={disabled || !image} onChange={e => change(() => setPosition(p => ({ ...p, x: Number(e.target.value) })))} /></label>
    <label>Spostamento verticale <input aria-label="Posizione verticale" type="range" min="0" max="1" step="0.01" value={position.y}
      disabled={disabled || !image} onChange={e => change(() => setPosition(p => ({ ...p, y: Number(e.target.value) })))} /></label>
    <button type="button" disabled={disabled || !image || !!error} onClick={() => { onConfirm(crop); setConfirmed(true); }}>
      {confirmed ? "Ritaglio confermato" : "Conferma ritaglio"}
    </button>
  </div>;
}
